import { createSelector } from '@reduxjs/toolkit';
const reduxTakeRefMediasReducer = (state) => state.reduxTakeRefMedias;
export const reduxTakeRefMediasDataSelector = createSelector(reduxTakeRefMediasReducer, (reducer) => reducer.data);
